import React from 'react'
import LocationLevelService from '../Service/locationLevelService'
import FormInput from './formInput'
import ModalHapus from './modalHapus'
import {config} from '../Config/config'
import './locationlevel.css'


export default class index extends React.Component {

    LocationLevelModel = {
        _id: "",
        name: "",
        abbreviation: "",
        created_by:  localStorage.getItem(config.userid),
        // created_on: new Date(),
        created_on: "",
        modified_by: "",
        modified_on: "",
        deleted_by: "",
        deleted_on: "",
        is_delete: false

    }

    constructor() {
        super()
        this.state = {
            List: [],
            Model: this.LocationLevelModel,
            Mode: "",
            ShowModal: false,
            ShowModalDel: false,
            errors: {},
            filter: {
                search: '',
            }

        }
    }

    //function untuk mengambil semua data di DB Variant di backend
    //memanggil API
    loadlist = async () => {
        // const respond = await CustRelationService.getAll()
        const respond = await LocationLevelService.getAll(this.state.filter)
        console.log(respond)

        if (respond.success) {
            this.setState({
                List: respond.result,
            })
        }
        // console.log(this.state.List)
    }

    componentDidMount() {
        this.loadlist()
        // console.log(this.VariantModel)
        //untuk cek CategoryModel udah ada di inspect browser
    }

    //funct untuk masukan input ke VariantModel
    //buat simpan data semendata dari form input
    //
    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                // ... => agar sesuai dgn paket locationLevelModel
                [name]: value
            }
        })
    }

    //function untuk CHECKED
    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }


    //button submit
    saveHandler = async () => {
        if (this.handleValidation()) {
            if (this.state.Mode == "Ubah Level Lokasi") {
                const respond = await LocationLevelService.editData(this.state.Model)
                if (respond.success) {
                    alert("Success Update Data")
                    this.setState({
                        Model: this.LocationLevelModel,
                        ShowModal: false
                    })
                    this.loadlist()

                }
            } else if (this.state.Mode == "Hapus Level Lokasi") {

                this.state.Model.is_delete = true
                //mengubah is_delete yang dihapus dari false menjadi true
                //hilang dr output, masih ada di db

                const respond = await LocationLevelService.editDataDelete(this.state.Model)
                if (respond.success) {
                    alert("Succes Delete Data")
                    this.setState({
                        Model: this.LocationLevelModel,
                        ShowModalDel: false
                    })
                    this.loadlist()
                }

            } else {
                const respond = await LocationLevelService.addData(this.state.Model)
                if (respond.success) {
                    alert("Succes Save Data")
                    this.setState({
                        Model: this.LocationLevelModel,
                        ShowModal: false
                    })
                    this.loadlist()
                }
            }

        } else {
            alert("Form has errors")
        }
    }


    //button EDIT
    editHandler = async (_id) => {
        const respond = await LocationLevelService.getById(_id)

        console.log(respond)

        this.setState({
            Mode: "Ubah Level Lokasi",
            ShowModal: true
        })

        if (respond.success) {
            this.setState({
                Model: respond.result
            })
        }
    }

    //button DELETE
    deleteHandler = async (_id) => {
        // console.log(_id)

        const respond = await LocationLevelService.deleteData(_id)
        this.setState({
            ShowModalDel: true
        })
        if (respond.success) {
            alert("Success Delete Data")
            this.loadlist()
        }
    }

    //button DELETE 2
    // deleteHandler2 = async () => {
    //     const respond = await LocationLevelService.deleteData(this.state.Model._id)

    //     if (respond.success) {
    //         alert("Success Delete Data")
    //         this.loadlist()
    //         this.setState({
    //             ShowModalDel: false
    //         })
    //     }
    // }

    createHandler = () => {
        this.setState({
            Mode: "Tambah Level Lokasi",
            ShowModal: true,
            Model: this.LocationLevelModel
        })
        console.log(this.state.ShowModal)

    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false,
            ShowModalDel: false
        })
    }

    //filter
    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    handleValidation() {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "* Nama level lokasi harus diisi";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    hapusHandler = async (_id) => {
        const respond = await LocationLevelService.getById(_id)

        console.log(respond)

        this.setState({
            Mode: "Hapus Level Lokasi",
            ShowModalDel: true
        })

        if (respond.success) {
            this.setState({
                Model: respond.result
            })
        }
    }


    render() {
        const { List, Model, ShowModal, errors, Mode } = this.state

        return (
            <div>
                <div class="container">
                    <div class="text-center">
                        <br />
                        <h1>Level Lokasi</h1>
                    </div>
                    <br /><br />



                    <div class="input-group col-5 mb-1 float-left">
                        <input class="form-control rounded-left miring floating" type="text" placeholder="cari berdasarkan nama" onChange={this.filterHandler("search")} />
                        <div class="input-group-append">
                            <button class="btn btn-primary rounded-right" type="button" onClick={this.loadlist}>
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>

                    <div class="input-group col-5 mb-1 float-left">
                        
                    </div>
                    
                    <button type="button" class="btn btn-success mb-3 float-right tambah" onClick={this.createHandler}><i class="fa fa-plus" ></i>       
                    <i> </i>Tambah Level Lokasi</button>




                    <table class="table table-striped">
                        <thead>
                            <br />
                            <tr class="text-center bg-primary">

                                <th scope="col">Nama</th>
                                <th scope="col">Nama Singkat</th>
                                <th scope="col">#</th>

                            </tr>
                        </thead>
                        <tbody>
                            {
                                List.map(data => {
                                    return (
                                        <tr class="text-center">
                                            <td>{data.name}</td>
                                            <td>{data.abbreviation}</td>
                                            <td>

                                                {/* <button class="btn btn-primary" onClick={() => this.editHandler(data._id)}>Ubah</button>
                                                <button type="button" class="btn btn-danger" onClick={() => this.hapusHandler(data._id)}>Hapus</button> */}
                                                <button type="button" class="btn fa fa-pencil m-r-5" onClick={() => this.editHandler(data._id)}></button>
                                                <button type="button" class="btn fa fa-trash-o m-r-5" onClick={() => this.hapusHandler(data._id)}></button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {/* <FormInput /> */}
                    <FormInput
                        changeHandler={this.changeHandler}
                        checkedHandler={this.checkedHandler}
                        saveHandler={this.saveHandler}
                        editHandler={this.editHandler}
                        Model={Model}
                        ShowModal={ShowModal}
                        createHandler={this.createHandler}
                        cancelHandler={this.cancelHandler}
                        handleValidation={this.handleValidation}
                        errors={errors}
                        Mode={Mode}

                    />
                    {/* //mengirim changeHandle ke FOrmInput */}

                    {/* <FormInput /> */}
                    <ModalHapus
                        changeHandler={this.changeHandler}
                        saveHandler={this.saveHandler}
                        createHandler={this.createHandler}
                        ShowModalDel={this.state.ShowModalDel}
                        cancelHandler={this.cancelHandler}
                        saveHandler={this.saveHandler}
                        List={List}
                        Model={this.state.Model}
                    />

                </div>

            </div>
        )
    }
}


